import { render, staticRenderFns } from "./ExpulsionPl.vue?vue&type=template&id=a6b2dade&scoped=true"
import script from "./ExpulsionPl.vue?vue&type=script&lang=js"
export * from "./ExpulsionPl.vue?vue&type=script&lang=js"
import style0 from "./ExpulsionPl.vue?vue&type=style&index=0&id=a6b2dade&prod&lang=css"
import style1 from "./ExpulsionPl.vue?vue&type=style&index=1&id=a6b2dade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2dade",
  null
  
)

export default component.exports